import React, { useState, useEffect } from 'react';
import AuthModal from './../AuthModal/AuthModal';

const AuthToggle = ({isLOpen, onLClose, settings}) => {
  const [isOpen, setIsOpen] = useState(isLOpen);
  const [showForgot, setShowForgot] = useState(false);

  useEffect(() => {
	if(isLOpen == true) {
		setShowForgot(false);
		setIsOpen(isLOpen);
	}
    return () => {
    };
  }, [isLOpen]);

  return (
    <>
      <AuthModal
        isOpen={isOpen}
		settings={settings}
        onClose={() => {setIsOpen(false); onLClose();}}
        showForgot={showForgot}
		onshowForgot={(val) => setShowForgot(val)}
      />
    </>
  );
};

export default AuthToggle;
